import Config from "src/config";
import { api, Api } from "../MainService/api";
import { ErrorKind } from "../MainService/apiProblem";
import { ResponseKind } from "../MainService";

const USER_URL = Config.USER_URL;

export interface Subject {
  id?: string; // id may or may not be present depending on backend implementation
  name: string;
}

export class UserApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  /**
   * Fetches the list of all subjects available for the child chat.
   * Backend endpoint: GET /users/get-all-subjects
   */
  async getAllSubjects(childUsername?: string) {
    try {
      const response = await this.api.apisauce.get<Subject[]>(
        `${USER_URL}/get-all-subjects${
          childUsername ? `?child_username=${childUsername}` : ""
        }`
      );
      // Pass `true` to skip default error handling (same pattern as other services)
      const data = await this.api.getResponse(response, true);
      return data;
    } catch (e) {
      console.error("Error fetching subjects:", e);
      return { kind: ErrorKind.BAD_DATA_ERROR };
    }
  }
}

export const userService = new UserApi(api);
